import { motion } from 'framer-motion';
import { TECH_STACK, TECH_TICKER } from '../../lib/site';

export default function TechStack() {
    return (
        <section
            data-testid="home-tech-stack"
            className="relative py-20 lg:py-24"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <span className="dt-section-eyebrow">POWERED BY</span>
                <h2 className="font-display mt-4 text-3xl sm:text-4xl font-semibold tracking-tight">
                    Engineered with <span className="dt-gradient-text">advanced technology</span>
                </h2>
                <p className="mt-3 text-muted-foreground max-w-2xl mx-auto">
                    A modern stack across engineering, AI, data, cloud, cybersecurity, and connected systems — chosen for reliability and the freedom to evolve.
                </p>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
                    {TECH_STACK.map((t, i) => {
                        const Icon = t.icon;
                        return (
                            <motion.div
                                key={t.label}
                                initial={{ opacity: 0, y: 12 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: '-40px' }}
                                transition={{ duration: 0.45, delay: (i % 4) * 0.05 }}
                                className="dt-glass rounded-xl px-4 py-5 flex flex-col items-center gap-2 hover:border-primary/40 transition-colors"
                            >
                                <span className="h-10 w-10 rounded-lg bg-white/5 border border-white/10 inline-flex items-center justify-center text-primary">
                                    <Icon className="h-5 w-5" />
                                </span>
                                <span className="font-mono text-[11px] tracking-[0.18em] text-foreground/85 uppercase">{t.label}</span>
                            </motion.div>
                        );
                    })}
                </div>

                {/* Marquee */}
                <div className="mt-10 overflow-hidden border-y border-white/5 py-4 mask-image">
                    <div className="flex gap-10 dt-marquee-track whitespace-nowrap text-xs font-mono uppercase tracking-[0.22em] text-muted-foreground">
                        {[...TECH_TICKER, ...TECH_TICKER, ...TECH_TICKER].map((label, i) => (
                            <span key={`${label}-${i}`} className="inline-flex items-center gap-2">
                                <span className="h-1.5 w-1.5 rounded-full bg-primary/70" />
                                {label}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
